import React, { FunctionComponent, useEffect, useState } from 'react';
import { Alert, Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../helpers/use-store';
import { useTranslation } from 'react-i18next';
const { Paragraph } = Typography;

const SESSION_STORAGE_KEY = 'payment-issue-modal-dismissed';

const PaymentBanner: FunctionComponent = observer(() => {
  const { t } = useTranslation();
  const {
    dataStore: { userStore },
  } = useStore();
  const [affected, setAffected] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const openSupportChat = () => {
    if (typeof window !== 'undefined' && window.Featurebase) {
      window.Featurebase('show');
    }
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await userStore.getPaymentIssueStatus();
        if (cancelled) return;
        setAffected(result.affected);

        // Auto-open the modal once per session so the user explicitly
        // acknowledges the outage. The banner stays visible after dismissal.
        const dismissed =
          sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';
        if (result.affected && !dismissed) {
          setModalOpen(true);
        }
      } catch (e) {
        // Silent failure — if the status endpoint is down we just don't
        // show the banner. Better than blocking the whole layout.
        console.warn('payment-issue-status failed', e);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userStore]);

  if (!affected) return null;

  const handleClose = () => {
    setModalOpen(false);
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
  };

  return (
    <>
      <Alert
        className="payment-banner"
        type="warning"
        banner
        showIcon
        message={
          <span>
            {t('paymentBanner.message')}{' '}
            <Button type="link" size="small" onClick={openSupportChat}>
              {t('paymentBanner.supportChat')}
            </Button>
            <Button type="link" size="small" onClick={() => setModalOpen(true)}>
              {t('paymentBanner.learnMore')}
            </Button>
            .
          </span>
        }
      />

      <Modal
        title={t('paymentBanner.modal.title')}
        open={modalOpen}
        onCancel={handleClose}
        onOk={handleClose}
        okText={t('paymentBanner.modal.ok')}
        cancelText={t('paymentBanner.modal.cancel')}
      >
        <Paragraph>{t('paymentBanner.modal.paragraph1')}</Paragraph>
        <Paragraph>
          <strong>{t('paymentBanner.modal.paragraph2Bold')}</strong>
          {t('paymentBanner.modal.paragraph2Rest')}
        </Paragraph>
        <Paragraph>
          {t('paymentBanner.modal.paragraph3')}{' '}
          <Button type="link" size="small" onClick={openSupportChat}>
            {t('paymentBanner.supportChat')}
          </Button>{' '}
          {t('paymentBanner.modal.paragraph3Rest')}
        </Paragraph>
      </Modal>
    </>
  );
});

export default PaymentBanner;
